import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataLoadService } from 'src/app/shared/services/data-load.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
import { globalVariables } from 'src/app/core/constants/globalVariables';

@Component({
  selector: 'app-business-unit-org',
  templateUrl: './../../../templates/forms/modals/business-unit-org.component.html'
})
export class BusinessUnitOrgComponent implements OnInit {

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "BusinessUnitListTwoId"

  businessUnitList: any[] = [];

  constructor(private dataLoadService: DataLoadService,
    public langService: LangService,
    public gridService: GridService) {
      this.colObj = [
        { headerName: 'Department', field: 'BU_NAME', sortable: true, resizable: true, hide: false },
        { headerName: 'BU Name Org', field: 'BU_NAME_ORG', sortable: true, resizable: true, hide: false }
      ];
     }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId); 
  }

  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.dataLoadService.load('FG_HR_COMM_BU_NAME').subscribe(results=>{
      this.businessUnitList = results.body;
          
    });
  }

  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next(_item);
  }

}
